import { Avatar, Grid, IconButton, InputAdornment } from "@mui/material"
import AppDialog from "../../../components/Common/AppDialog"
import CustomButton from "../../../components/Form/CustomButton"
import { Icon } from "@iconify/react/dist/iconify.js"
import CustomTextField from "../../../components/Form/CustomTextField"
import { useState } from "react"

const ChangePasswordModal = ({ open, close, submit, error }) => {
    const [showPW, setShowPW] = useState(false);
    const [showNewPW, setShowNewPW] = useState(false);
    const [showConfirmPW, setShowConfirmPW] = useState(false);
    const [password, setPassword] = useState();
    const [newPassword, setNewPassword] = useState();
    const [confirmPassword, setConfirmPassword] = useState();

    return (
        <AppDialog
            open={open}
            title={"Change password"}
            close={() => close()}
            positiveTitle={'Change password'}
            positivePress={() => submit({current_password: password, new_password: newPassword, confirm_password: confirmPassword})}
            cancelButton={true}
            width={'40%'}
        >
            <Grid container spacing={2}>
                <Grid item sm={12}>
                    <CustomTextField
                        title={'Current Password'}
                        placeholder={'Enter current password'}
                        typePw={showPW ? 'text' : 'password'}
                        values={password}
                        error={error?.current_password}
                        onChange={(e) => setPassword(e)}
                        InputProps={{
                            endAdornment: <IconButton
                                aria-label="toggle password visibility"
                                onClick={(e) => setShowPW(!showPW)}
                                edge="end"
                            >
                                {showPW ? <Icon icon="mdi:eye-outline" width="24" height="24" color="#BDBDBD"/> : <Icon icon="mdi:eye-off-outline" width="24" height="24" color="#BDBDBD"/>}
                            </IconButton>,
                        }}
                    />
                </Grid>
                <Grid item sm={12}>
                    <CustomTextField
                        title={'New Password'}
                        placeholder={'Enter new password'}
                        values={newPassword}
                        error={error?.password}
                        typePw={showNewPW ? 'text' : 'password'}
                        onChange={(e) => setNewPassword(e)}
                        InputProps={{
                            endAdornment: <IconButton
                                aria-label="toggle password visibility"
                                onClick={(e) => setShowNewPW(!showNewPW)}
                                edge="end"
                            >
                                {showNewPW ? <Icon icon="mdi:eye-outline" width="24" height="24" color="#BDBDBD"/> : <Icon icon="mdi:eye-off-outline" width="24" height="24" color="#BDBDBD"/>}
                            </IconButton>,
                        }}
                    />
                </Grid>
                <Grid item sm={12}>
                    <CustomTextField
                        title={'Confirm New Password'}
                        placeholder={'Re-enter new password'}
                        values={confirmPassword}
                        error={error?.confirm_password}
                        onChange={(e) => setConfirmPassword(e)}
                        typePw={showConfirmPW ? 'text' : 'password'}
                        InputProps={{
                            endAdornment: <IconButton
                                aria-label="toggle password visibility"
                                onClick={(e) => setShowConfirmPW(!showConfirmPW)}
                                edge="end"
                            >
                                {showConfirmPW ? <Icon icon="mdi:eye-outline" width="24" height="24" color="#BDBDBD"/> : <Icon icon="mdi:eye-off-outline" width="24" height="24" color="#BDBDBD"/>}
                            </IconButton>,
                        }}
                    />
                </Grid>
            </Grid>
        </AppDialog>
    )
}
export default ChangePasswordModal;